// @flow
import * as React from 'react';

import { Field } from 'redux-form';
import { FormRadio, FormSelect } from '../../../../components/index';

import { BYE_ROUNDS, getLeagueFinalFormat, league_tooltips } from '../../../../helpers/index';

type Props = {
	is_finals?: boolean,
	league_size: any,
	league: {
		status: string,
		draft_status: string,
	},
	is_final_start_round: boolean;
	finals_format: number;
	final_rounds: Array<{ value: number, text: string }>;
};

export const AdvancedLeagueSettings = (
	{ is_finals, league_size, league, final_rounds, is_final_start_round }: Props
) => (
	<div>
		<FormRadio
			label='League Finals Series'
			name='finals'
			elements={[
				{
					value: 1,
					text: 'Yes',
				},
				{
					value: 0,
					text: 'No',
				},
			]}
			tooltip={league_tooltips.finals}
			is_disabled={league.status !== 'scheduled'}
		/>

		<Field
			label='League Finals Series Format'
			name='finals_format'
			options={getLeagueFinalFormat({ league_size })}
			component={FormSelect}
			tooltip={league_tooltips.finals_format}
			is_disabled={!is_finals || league.status !== 'scheduled'}
		/>
		<Field
			label='League Finals Start Round'
			name='finals_start_round'
			options={final_rounds}
			component={FormSelect}
			tooltip={league_tooltips.finals_start_round}
			is_disabled={!is_final_start_round}
		/>
		<Field
			label='Play Opponents'
			name='play_times'
			options={[
				{
					value: 'flexible',
					text: 'Flexible',
				},
				{
					value: 'once',
					text: 'Once',
				},
				{
					value: 'twice',
					text: 'Twice',
				},
			]}
			component={FormSelect}
			tooltip={league_tooltips.play_times}
			is_disabled={league.status !== 'scheduled'}
		/>
		{BYE_ROUNDS.length ? (
			<FormRadio
				label='Bye Rounds'
				name='bye_rounds'
				elements={[
					{
						value: 1,
						text: 'On',
					},
					{
						value: 0,
						text: 'Off',
					},
				]}
				tooltip={league_tooltips.bye_rounds}
				is_disabled={league.status !== 'scheduled'}
			/>
		) : null}


	</div>
);

export default AdvancedLeagueSettings;


// WEBPACK FOOTER //
// ./src/pages/league/leagueSettings/forms/AdvancedLeagueSettings.js